module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAUtJREFUSEvt1b9Lw0AUB/DvS+hgdNfqLqh/QB0Ef9AiZFDwP4hL2sEMorvO+gc0g1CKf4HKRUR3/wIdXFXi4iAktSXekxRbYk31GnFQvOXg3ePD473jjvC2jNLBOOWiQ2bMESHXiX+y30hNLjZOKndpOdQJDpvVM4BKCmA7hZkFQJOsy4U0PAG7EQBdFQbIkswjGsFJqzwJvwDQ1GFpBaJSGzJdhxgbvZVnhlliJzy1d+NCDLNaJtCm5OZSw3Nu41h2GIjAqBP4kQnPBFqLwUDYM9+C+7TsIRD22E/AfiDs/Jfw+d4KZqfbBaSuyysfxe2j5JkafLG/isLUaH/42kdxKwOsfvW6mWoV/z74f3gZZvanboVhuhEN9NB/7Bgz7kPPnuh5Kwb7mtIHwbVAlK13sLHs5klHnRnzip9p12agBeA45OY6POcpPngFH+C8F1wB50MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_file.png
// module id = 8fi0
// module chunks = 1